import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { slug } from '../../../services/SlugService';

export const OpenPlanLink = (props) => {
  const letter = props.data.clientName
    .toLowerCase()
    .trim()
    .replace(/[^a-z]/, '-')[0];
  const page = props.data.planAdministratorEmail ? 'manager' : 'client';

  const btnId = `myBtn${slug(props.data.planName).replace(/-/g, '')}`;

  return (
    <NavLink
      to={`/portfolio/${letter}/${slug(props.value)}/${page}`}
      id={btnId}>
      {props.value}
    </NavLink>
  );
};

OpenPlanLink.propTypes = {
  value: PropTypes.string,
  data: PropTypes.object,
  rowIndex: PropTypes.number,
};

export default connect(null, {})(OpenPlanLink);
